// extracted by mini-css-extract-plugin
export var quillEditor = "_os-1";
export var variable = "_os-0";